import EventDispatcher from '../../../../../shared/lib/html5-software-library/src/ranj/util/EventDispatcher';

export default class PuzzleModel extends EventDispatcher {


    constructor(location, target, items) {
        super();
        this._location = location;
        this._target = target;
        this._items = items;
        this.reset();
    }

    /**@type {Number} Index of target item.*/
    get target() {
        return this._target;
    }

    /**@type {Number} Index of location.*/
    get location() {
        return this._location;
    }

    /**@type {Array<Number>} Array of item indexes.*/
    get slots() {
        return this._slots;
    }


    reset() {
        this._slots = this._items.slice(0);
        this._updateScore();
    }

    setSlot(index, value) {
        this._slots[index] = value;
    }

    getSlot(index) {
        return this._slots[index];
    }

    _applyState(state) {
        //TODO
        this._updateScore();
    }

    getState() {
        //TODO
        return this._slots;
    }


    /*****************************
     *      SCORING RELATED
     *****************************/

    _updateScore() {
        
    }


    /*****************************
     *      SAVEGAME RELATED
     *****************************/

    toObject() {
        //make state serializable (convert Sets into Arrays)
        const state = this.getState();
        return {
            state: state
        }
    }

    /**
     * 
     * @param {Object} object - see keys in PuzzleModel.toObject()
     */
    setFromObject(object) {
        const state = object.state;
        if (state) {
            this._applyState(state);
        }
    }
}